import {
  type RouteObject,
} from "react-router";
import TaskManagerListApp from "taskManager/List/App";

declare let viewModel: any;

export const taskManagerRoute: RouteObject = {
  path: "taskmanager",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: TaskManagerListApp,
  }]
};